<template>
  <div>
    <div style="height:50px;"></div>
    <div class="header-fixed">
      <div class="hd-container hd-headers">
        <ul class="nav2 flex-row space-between">
          <li class="logo_pic">
            <h1>
              <router-link :to="{path:'/'}">
                <img :src="host?'../../static/img/logo_hsfx.png':about_us.logo" alt="公司logo">
              </router-link>
            </h1>
          </li>
          <li v-if="citylist.length>0">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                {{city_name}}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item, index) in citylist"
                  :key="index"
                  :class="{'active':city_name==item.name}"
                  @click.native="chooseCity(item)"
                >{{item.name}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li v-else>{{city_name}}</li>
          <li>
            <router-link :to="{path:'/'}">首页</router-link>
          </li>
          <li>
            <a @click="askanswer">租赁问答</a>
          </li>
          <li v-if="isUser||isMerchant">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                我的
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="my-dropdown">
                <el-dropdown-item
                  v-for="(v,i) in linkList"
                  :key="i"
                  :class="{'active':activeIdx==i}"
                >
                  <router-link @click.native="jump(v,i)" :to="v.path">{{v.title}}</router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <a @click="logout">退出账号</a>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li v-if="!isUser&&!isMerchant" @click="login()">
            <a>登录/注册</a>
          </li>
          <li @click="supplier_login">
            <a>商家入口</a>
          </li>
          <li @click="joinUs">
            <a>商家入驻</a>
          </li>
          <li class="mianyajin_btn">
            <router-link target="_blank" :to="{path:'/download'}" style="color:#FFF;display:;">我要免押金</router-link>
          </li>
        </ul>
        <div class="tel_num">18513127642（微信同号）</div>
      </div>
      <div class="app-download flex-row">
        <el-dropdown>
          <span class="el-dropdown-link">
            <i class="el-icon-mobile-phone yzy-phone"></i>
            APP下载
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="app-download-dropdown">
              <img src="/static/img/code.png" width="150" height="150" alt="APP下载">
              <p class="code-line-1 c9 f12">APP下载</p>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <el-dialog title="商家入驻" :visible.sync="dialogVisible" width="600px">
      <span>
        请联系我们的商务代表（赵先生）：
        <i class="red-phone">18810882416</i>
      </span>
    </el-dialog>
  </div>
</template>


<script>
import { mapState, mapGetters } from "vuex";
import { logout, aboutus } from "../api/member/member.js";
import { cityList } from "../api/index.js";
export default {
  data() {
    return {
      dialogVisible: false,
      citylist: this.$cookies.get("citylist") || [],
      city_name: this.$cookies.get("city_name") || "北京",
      about_us: {
        logo: "",
        mobile: ""
      },
      linkList: [
        { path: "/my", title: "个人资料" },
        { path: "/mywallet", title: "我的钱包" },
        { path: "/myorder", title: "我的订单" },
        { path: "/mymessage", title: "我的消息" },
        { path: "/MyShoucang", title: "我的收藏" },
        { path: "/newMyCart", title: "租物车" },
        { path: "/shouhuoDizhi", title: "收货地址" },
        { path: "/userCouponList", title: "优惠券管理" },
        { path: "/userpassword", title: "修改密码" },
        { path: "/myinvoice", title: "发票管理" }
      ],
      host:window.location.host.indexOf('zulin')>-1
    };
  },
  computed: {
    ...mapGetters("userOrMerchant", {
      isUser: "getUserStatus"
    }),
    ...mapState({
      isMerchant: state => state.userOrMerchant.merchantStatus
    }),
    ...mapGetters("routerStatus", {
      activeIdx: "getUserRouterIdx"
    })
  },
  methods: {
    jump(v, i) {
      this.$store.dispatch("routerStatus/changeIdxAction", i);
      // this.$router.push(v.path);
    },
    login() {
      this.$router.push("/UserLogin");
    },
    supplier_login() {
      if (this.$store.state.userOrMerchant.merchantStatus) {
        this.$router.push("/newMerchant");
        this.$store.dispatch("routerStatus/changeIdxActionMerchant", 0);
      } else {
        this.$router.push("/BusinessUser");
      }
    },
    logout() {
      this.$store.commit("userOrder/changeCartNum", 0);
      if (this.$store.state.userOrMerchant.merchantStatus) {
        this.$cookies.set("uid", "");
        this.$cookies.set("supplier_id", "");
        this.$cookies.set("browser_token", "");
        this.$cookies.set("uicredit_lined", "");
        this.$cookies.set("wallet_amount", "");
        this.$store.dispatch("userOrMerchant/userStatusAction", false);
        this.$store.dispatch("userOrMerchant/merchantStatusAction", false);
        this.$router.replace("/BusinessUser");
      } else {
        this.$cookies.set("uid", "");
        this.$cookies.set("supplier_id", "");
        this.$cookies.set("browser_token", "");
        this.$cookies.set("uicredit_lined", "");
        this.$cookies.set("wallet_amount", "");
        this.$store.dispatch("userOrMerchant/userStatusAction", false);
        this.$store.dispatch("userOrMerchant/merchantStatusAction", false);
        this.$router.replace("/UserLogin");
      }
    },
    askanswer() {
      this.$router.push("/askanswer1");
    },
    getAboutUs() {
      //判断关于我们数据是否存在
      var logo = this.$cookies.get("logo");
      var mobile = this.$cookies.get("mobile");
      if (logo == null || mobile == null) {
        aboutus().then(res => {
          if (res.data.code != "error") {
            this.about_us = res.data.data;
            this.$cookies.set("logo", res.data.data.logo, 60 * 60 * 24);
            this.$cookies.set("mobile", res.data.data.mobile, 60 * 60 * 24);
          }
        });
      } else {
        this.about_us.logo = logo;
        this.about_us.mobile = mobile;
      }
    },
    //选择城市
    chooseCity(item) {
      this.$cookies.set("city_id", item.id);
      this.$cookies.set("city_name", item.name);
      this.$cookies.set("city_is_changed", true);
      this.city_name = item.name;
      this.$parent.$refs["view"].city_name = item.name;
      this.$parent.$refs["view"].city_id = item.id;
      if (this.$parent.$refs["view"].initData) {
        this.$parent.$refs["view"].initData();
      }
      if (this.$route.path == "/GoodsList") {
        this.$parent.$refs["view"].query.city_id = item.id;
        this.$parent.$refs["view"].query.category_id = 0;
        this.$parent.$refs["view"].activeClass = 0;
        this.searchAction();
      }
    },
    searchAction() {
      this.$emit("transferKw", this.keywords);
    },
    getCityData() {
      cityList().then(res => {
        if (res.data.code != "error") {
          this.citylist = res.data.data || [];
          this.$cookies.set(
            "citylist",
            JSON.stringify(res.data.data),
            60 * 60 * 24
          );
        }
      });
    },
    initData() {
      this.city_name =
        !this.$cookies.get("city_name") ||
        this.$cookies.get("city_name") == "undefined"
          ? "北京"
          : this.$cookies.get("city_name");
      this.getCityData();
      this.getAboutUs();
    },
    joinUs() {
      this.dialogVisible = true;
    }
  },
  created() {
    this.initData();
  }
};
</script>

<style scoped>
.header-fixed {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 201;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #eee;
}
.nav2 {
  width: 700px;
  padding: 11px 0 13px 0;
  display: flex;
  justify-content: space-between;
}

.hd-headers {
  display: flex;
  justify-content: space-between;
}

.nav2 li {
  height: 26px;
  margin-left: 20px;
  font-size: 12px;
  line-height: 26px;
}
.nav2 .mianyajin_btn {
  padding: 0 4px;
  border-radius: 4px;
  /* background-image: -webkit-linear-gradient(right, #ffd778, #fd314a); */
  background: -webkit-linear-gradient(to right, #ffd778, #fd314a);
  /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(to right, #ffd778, #fd314a);
  /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(to right, #ffd778, #fd314a);
  /* Firefox 3.6 - 15 */
  background: linear-gradient(to right, #ffd778, #fd314a);
}

.nav2 a {
  color: #333;
}
.tel_num {
  font-size: 15px;
  color: #ff6b56;
  line-height: 50px;
  text-decoration: none;
  cursor: pointer;
}
.logo_pic img {
  width: 90px;
  margin-top: -9px;
}
.hd-container {
  width: 100%;
  height: 50px;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  display: flex;
  justify-content: space-between;
}
.hd-container {
  max-width: 1140px;
}
.el-dropdown-link {
  cursor: pointer;
  font-size: 12px;
  color: #333;
  outline: none !important;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.el-dropdown-menu__item,
.el-dropdown-menu__item a {
  line-height: 24px;
  color: #555;
  font-size: 12px;
  text-decoration: none;
}
.active,
.el-dropdown-menu__item.active a {
  color: #ff6b56;
}
.app-download {
  position: absolute;
  top: 0;
  right: 0;
  width: 150px;
  height: 50px;
  font-size: 18px;
  color: #6c6c6c;
  align-items: center;
  justify-content: center;
}
.app-download .el-dropdown-link {
  font-size: 18px;
  color: #6c6c6c;
}
.yzy-phone {
  font-size: 20px;
}
.code-line-1 {
  text-align: center;
  line-height: 20px;
  font-size: 13px;
  margin: 0;
}
.code-line-2 {
  text-align: center;
  line-height: 20px;
  font-size: 14px;
  margin: 0;
}
.code-bot {
  text-align: center;
  line-height: 37px;
  font-size: 15px;
}
.red-phone {
  font-size: 20px;
  color: #ff6b56;
}
.logo_pic h1{
  font-size: 12px;
}
.my-dropdown .el-dropdown-menu__item{
  padding:0;
}
.my-dropdown .el-dropdown-menu__item a{
  display: block;
  width:100%;
  padding:0 20px;
}
</style>
<style>
.app-download-dropdown.el-dropdown-menu__item:focus,
.app-download-dropdown.el-dropdown-menu__item:not(.is-disabled):hover {
  background: #fff;
  color: #555;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue